// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentCard__container__3BEq8","title":"ContentCard__title__2QFRV","content":"ContentCard__content__g4-JS","footer":"ContentCard__footer__2B7if"};